import React, { useRef, useState, useEffect } from 'react'
import BrightcovePlayer from '../../../spa/components/brightcovePlayer/BrightcovePlayer.jsx'
import { BRIGHTCOVE_VIDEO_PLAYER_ID } from '../../../spa/utility'
import { camelCase } from 'lodash'
import DOMPurify from 'dompurify'

const isDetailsPage = window.location.pathname.includes('details')

const formatSeconds = (seconds) => {
  const totalSeconds = (Math.floor(seconds) % 60).toString().slice(0, 2)

  return totalSeconds.length === 1 ? '0' + totalSeconds : totalSeconds
}

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const fomattedSeconds = formatSeconds(seconds)

  return `(${minutes}:${fomattedSeconds})`
}

function VideoPlayer({
  playlistId,
  isInline = false,
  autoplay = false,
  dataTags,
  pdfLinks,
}) {
  const wrapper = useRef()

  const [mediaInfo, setMediaInfo] = useState()

  const onFirstplay = () => {
    if (wrapper.current) {
      wrapper.current.classList.add('currently-playing')
      const videoList = document?.querySelectorAll('.video-player')
      if (videoList && videoList?.length > 0) {
        videoList.forEach((video) => {
          const videoElement = video.querySelector('video-js')
          if (
            videoElement &&
            videoElement.player &&
            videoElement.dataset?.playlistId !== playlistId
          ) {
            video.classList.remove('currently-playing')
          }
        })
      }
    }
  }

  const onEnded = () => {
    if (wrapper.current) {
      wrapper.current.classList.remove('currently-playing')
    }
  }

  const handleControlbarMenus = () => {
    // add analytics to brightcove video element - tracking play/pause
    const videoElement = dataTags
      ? document.querySelectorAll(`video[data-playlist-id='${playlistId}']`)[0]
      : null

    if (videoElement) {
      Object.keys(dataTags).forEach((tag) => {
        const baseTag = camelCase(tag.replaceAll('data-', ''))
        videoElement.dataset[baseTag] = dataTags[tag]
      })
    }
  }

  useEffect(() => {
    handleControlbarMenus()
  }, [])

  const { name, longDescription, duration } = mediaInfo || {}

  return (
    <div ref={wrapper} className={`video-player ${isInline ? 'inline' : ''}`}>
      <div className="player-container" data-analytics={name}>
        <BrightcovePlayer
          accountId={window.BRIGHTCOVE_PLAYER_ACCOUNT_ID}
          playlistId={playlistId}
          playerId={BRIGHTCOVE_VIDEO_PLAYER_ID}
          onVideoPlayCallback={onFirstplay}
          onVideoLoadStartCallback={setMediaInfo}
          onVideoEndCallback={onEnded}
          options={{ autoplay }}
        />
      </div>

      <div className="video-description-container">
        {!isDetailsPage && (
          <h4
            className="title"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(name) }}
          />
        )}

        <div
          className={`${isDetailsPage ? 'u-paddingTop2gu desc' : 'desc'}`}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(longDescription),
          }}
        />
        {pdfLinks.length != 0 &&
          pdfLinks.map((link, idx) => {
            const [linkText, linkUrl] = link.split(':')
            return (
              <a
                className="u-paddingRight1gu"
                key={idx}
                href={linkUrl}
                target="_blank"
                rel="noreferrer"
              >
                {linkText}
              </a>
            )
          })}
        <div className="duration">
          {(duration && formatTime(duration)) || ''}
        </div>
      </div>
    </div>
  )
}

export default VideoPlayer
